import { scheduleDTOtoDetailsBarInfo, scheduleDetailsBarText } from "@teams/cards";
import { TeamsRecipientGroupMember } from "@teams/types";
import { ScheduleDTO, SurveyDTO } from "@teams/types/api";
import React from "react";

import { StandUpCard } from "../../agile/pages/StandUp/StandUpCard/StandUpCardComponent";
import { StandUpScheduleCard } from "../../agile/pages/StandUp/StandUpScheduleCard/StandUpScheduleCardComponent";
import { SurveyCardComponent } from "../../survey/pages/SurveyTeamTab/ChannelSurveys/SurveyCardComponent";
import { useUserInfo } from "../actions/useUserInfo";
import { getPageContext } from "../utils/teamsHelpers";

export type GenericSurveyCardProps = {
  entry: SurveyDTO | ScheduleDTO;
  loadInstanceCallback?: () => void;
  loadSeriesCallback?: () => void;
  allowShowResults?: boolean;
};
export const GenericSurveyCard: React.FC<GenericSurveyCardProps> = ({
  entry,
  loadInstanceCallback,
  loadSeriesCallback,
  allowShowResults,
}) => {
  const { user } = useUserInfo();
  loadInstanceCallback = loadInstanceCallback ?? (() => {});
  loadSeriesCallback = loadSeriesCallback ?? (() => {});

  if (getPageContext() === "/agile") {
    if (entry.type === "agile-standup") {
      return (
        <StandUpCard
          user={user}
          key={entry.id}
          standup={entry}
          allowShowResults={false}
          title={entry.title}
          groupId={(entry.recipients[0] as TeamsRecipientGroupMember).groupId}
          seriesDisabled={false}
          schedule={undefined}
          showOwnerOptions={entry.role === "own"}
          onChanged={loadInstanceCallback}
          applicationType="agile"
          detailsBarText=""
        />
      );
    } else {
      const schedule = entry as ScheduleDTO;
      if (schedule.lastSurvey) {
        return (
          <StandUpCard
            user={user}
            applicationType="agile"
            key={schedule.id}
            standup={schedule.lastSurvey}
            allowShowResults={allowShowResults || true}
            title={schedule.template?.title || schedule.name}
            detailsBarText={scheduleDetailsBarText(scheduleDTOtoDetailsBarInfo(schedule), {
              activeCardDateFormat: false,
            })}
            schedule={schedule}
            groupId={(schedule.recipients[0] as TeamsRecipientGroupMember).groupId}
            seriesDisabled={schedule.state === "disabled"}
            showOwnerOptions={schedule.role === "own"}
            onChanged={loadSeriesCallback}
          />
        );
      } else {
        return (
          <StandUpScheduleCard
            user={user}
            key={schedule.id}
            schedule={schedule}
            onChanged={loadSeriesCallback}
          />
        );
      }
    }
  }

  const isSeries = entry.type === "rrule";
  const schedule = entry as ScheduleDTO;
  if (isSeries && schedule.lastSurvey) {
    return (
      <SurveyCardComponent
        key={entry.id}
        schedule={schedule}
        survey={{ ...schedule.lastSurvey, ...schedule.template, id: schedule.lastSurvey.id }}
        onChanged={loadInstanceCallback}
      />
    );
  } else if (isSeries && !schedule.lastSurvey) {
    return (
      <StandUpScheduleCard
        user={user}
        key={schedule.id}
        schedule={schedule}
        onChanged={loadSeriesCallback}
      />
    );
  }

  const survey = entry as SurveyDTO;
  return <SurveyCardComponent key={entry.id} survey={survey} onChanged={loadInstanceCallback} />;
};
